import { Euler, Matrix4, Vector3 } from 'three';
import { BoundingBox3 } from './BoundingBox3';

function computeBoundingPoints(size: Vector3) {
  const boundingBox = new BoundingBox3();

  return boundingBox.setFromCenterAndSize(new Vector3(0, 0, 0), size).points;
}

export class SBox3 {
  private _size: Vector3;
  private _position: Vector3;
  private _rotation: Vector3;
  private _matrix: Matrix4;
  constructor(size: Vector3, position: Vector3, rotation: Vector3) {
    this._size = size;
    this._position = position;
    this._rotation = rotation;

    const euler = new Euler(rotation.x, rotation.y, rotation.z); // XYZ顺序
    this._matrix = new Matrix4();
    this._matrix.makeRotationFromEuler(euler);
    this._matrix.setPosition(position);
  }

  get size() {
    return this._size;
  }

  get position() {
    return this._position;
  }

  get rotation() {
    return this._rotation;
  }

  get points() {
    const _this = this;
    const boxPoints: Vector3[] = [];
    computeBoundingPoints(this.size).forEach((boundingPoint) => {
      boxPoints.push(boundingPoint.applyMatrix4(_this._matrix));
    });

    return boxPoints;
  }
}
